import { createFileRoute } from "@tanstack/react-router";

import { CheckoutPage } from "@/components/Pages/Checkout";

export const Route = createFileRoute("/checkout/$token")({
  component: function CheckoutRoute() {
    const { token } = Route.useParams();
    return <CheckoutPage token={token} />;
  },
});
